import { faEdit } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Accordion, Button, Col, Row, Table } from '@themesberg/react-bootstrap'
import React, { useRef, useState, useEffect, useMemo } from 'react'
import ClientFilter from '../../../components/ClientFilter'
import PortalFilter from '../../../components/PortalFilter'
import Preloader from '../../../components/Preloader'
import EditUploadBanner from './EditUploadBanner'
import useBannerManagement from './useBannerManagement'
import Trigger from '../../../components/OverlayTrigger'
import { bannerType } from './constants'
import { motion } from 'framer-motion/dist/framer-motion'
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded'
import ActionMenu from './ActionMenu'
import DeblurIcon from '@mui/icons-material/Deblur'
import PaginationComponent from '../../../components/Pagination'
import NotificationIconContainer from '../../../components/NotificationIcon/NotificationIconContainer'
import { DeleteConfirmationModal } from '../../../components/ConfirmationModal'

import { HeaderRow, SectionHeaderWrap } from '../../../components/StyledComponents'
import { AddButtonStyled, ButtonContainer, ResponsiveTitle } from '../TransactionsBanking/style'
import { tableColumnHeaders } from './constants'
import useTableCustom from '../../../components/CusotmFilter'
import TableErrorMessage from '../../../components/TableErrorMessage'
import ImageModal from '../../../components/ImageModal'

export default () => {
  const {
    page,
    limit,
    setPage,
    setLimit,
    loading,
    handleDelete,
    handleCreateEdit,
    type,
    data,
    setShow,
    show,
    createUpdate,
    clientsFilterData,
    portalsFilterData,
    dispatch,
    SABanners,
    isHidden,
    validation,
    setValidation,
    totalPages,
    setDeleteModalShow,
    deleteModalShow,
    handleDeleteYes,
    selecteddeletebanner,
    setImageModal,
    imageModal,
    totalCount
  } = useBannerManagement()

  // const getCheckCreateBanner = () => {
  //   let showButton = false
  //   const uploadedBanner = SABanners && SABanners.length > 0 && Object.keys(SABanners[0].value) || []
  //   //  const isExit= bannerType.some(v => uploadedBanner.includes(v.value))
  //   if (uploadedBanner.length === bannerType.length) {
  //     showButton = true
  //   }
  //   return showButton;
  // }

  const isShowActionColumn = !isHidden({ module: { key: 'BannerManagement', value: 'U' } }) || !isHidden({ module: { key: 'BannerManagement', value: 'D' } })

  const dynamicTableHeaders = useMemo(() => {
    const headers = [...tableColumnHeaders.filter(col => col.value !== 'action')];
    if (isShowActionColumn) {
      headers.push({
        accessorKey: 'action',
        Header: 'Actions',
        value: 'action',
        label: 'Actions',
      });
    }

    return headers;
  }, [isShowActionColumn]);

  const {
    visibleColumns,
    pageData,
    customColSetting,
    noDataFound,
  } = useTableCustom(
    SABanners,
    dynamicTableHeaders, // already permission-filtered
    false,
    () => { },
    null,
    null,
    false,
    "",
    true,
    "BANNER_MANAGMENT_TABLE"
  );


  const headerRef = useRef(null);
  const filterRef = useRef(null);
  const paginationRef = useRef(null);
  const [tableMaxHeight, setTableMaxHeight] = useState("");


  useEffect(() => {
    const updateMaxHeight = () => {
      const headerHeight = headerRef.current?.offsetHeight || 0;
      const filterHeight = filterRef.current?.offsetHeight || 0;
      const paginationHeight = paginationRef?.current?.offsetHeight || 0;

      const responsiveTable = document.querySelector('.table-responsive');
      const totalHeight = headerHeight + filterHeight + paginationHeight;
      const availableHeight = window.innerHeight - totalHeight - 110;

      if (window.innerWidth < 1000) {
        // For smaller screens: reset to full height
        if (responsiveTable) {

          responsiveTable.style.maxHeight = '100%';
          responsiveTable.style.overflowY = 'unset';
        }
        setTableMaxHeight('100%');
        return;
      }
      else if (responsiveTable) {

        responsiveTable.style.maxHeight = `${availableHeight}px`;
        responsiveTable.style.overflowY = 'auto'; // ensure scrolling
        setTableMaxHeight(`${availableHeight}px`);
      }


    };

    updateMaxHeight();
    window.addEventListener("resize", updateMaxHeight);
    return () => window.removeEventListener("resize", updateMaxHeight);
  }, [visibleColumns, SABanners]);
  return (
    <>
      <SectionHeaderWrap ref={headerRef}>
        <HeaderRow>
          <Col xs={12} md={6}>
            <ResponsiveTitle className="title-text">
              Banner Management
            </ResponsiveTitle>
          </Col>


          <Col xs={12} md={6}>
            <div className="d-flex flex-column flex-md-row align-items-center justify-content-end gap-2">
              {/* Custom Column Setting */}
              <div style={{ maxWidth: '200px', flexShrink: 0 }}>
                {customColSetting}
              </div>
              {/* Button */}
              <motion.div
                initial={{ opacity: 0, scale: 0.5 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
              >
                <AddButtonStyled
                  variant="primary"
                  onClick={() => handleCreateEdit('Create', {})}
                  hidden={isHidden({ module: { key: 'BannerManagement', value: 'C' } })}
                >
                  <AddCircleOutlineRoundedIcon />
                  <span>Upload</span>
                </AddButtonStyled>
              </motion.div>



              {/* Notification Icon */}
              <div className="d-flex align-items-center">
                <NotificationIconContainer />
              </div>
            </div>
          </Col>

        </HeaderRow>
      </SectionHeaderWrap>

      {loading
        ? <Preloader />
        :
        visibleColumns?.length > 0 ? <>
          <div className='TableBg mt-4'>
            <Table striped responsive hover size='sm' className='text-center'>
              <thead className='thead-light'>
                <tr>
                  {visibleColumns.map((h) => (
                    <th key={h?.label}>{h?.label}</th>
                  ))}
                </tr>
              </thead>

              <tbody>


                {SABanners?.map(({ pageBannerId, bannerType, name, imageUrl }, index) => {
                  return (
                    <tr key={pageBannerId}>
                      {visibleColumns.map((col) => {
                        switch (col?.accessorKey) {
                          case 'id':
                            return <td key={col}>{pageBannerId}</td>;

                          case 'bannerType':
                            return <td key={col}>{bannerType}</td>;

                          case 'name':
                            return <td key={col}>{name}</td>;

                          case 'view':
                            return (
                              <td key={col}>
                                <span
                                  // onClick={() =>
                                  //   window.open(`${process.env.REACT_APP_S3_URL}/${imageUrl}`)
                                  // }
                                  onClick={() => setImageModal({
                                    isOpen: true,
                                    url: `${process.env.REACT_APP_S3_URL}/${imageUrl}`
                                  })}
                                  className="text-link"
                                  style={{ cursor: 'pointer' }}
                                >
                                  <img src={`${process.env.REACT_APP_S3_URL}/${imageUrl}`}
                                    style={{ width: '100px', height: 'auto', objectFit: 'contain', cursor: 'pointer' }}
                                  />

                                </span>
                              </td>
                            );

                          case 'action':
                            return (
                              <td key={col}>
                                <ActionMenu
                                  handleCreateEdit={handleCreateEdit}
                                  handleDelete={handleDelete}
                                  name={name}
                                  id={pageBannerId}
                                  thumbnail={imageUrl}
                                  bannerType={bannerType || ''}
                                  isHidden={isHidden}
                                  data={data}
                                />
                              </td>
                            );

                          default:
                            return null;
                        }
                      })}
                    </tr>
                  );
                })}


                {(!SABanners || SABanners?.length === 0) && (
                  <tr>
                    <td colSpan={5} className='text-danger text-center'>
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          {SABanners?.count !== 0 && !loading && (
            <PaginationComponent
              page={page}
              totalPages={totalPages}
              setPage={setPage}
              limit={limit}
              setLimit={setLimit}
              countText={"Total Banners :  "}
              totalCount={totalCount}
              showTotalCount={true}
            />
          )}
        </> : <TableErrorMessage />
      }

      <EditUploadBanner
        type={type}
        data={data}
        show={show}
        setShow={setShow}
        createUpdate={createUpdate}
        clientsFilterData={clientsFilterData}
        portalsFilterData={portalsFilterData}
        dispatch={dispatch}
        SABanners={SABanners}
        validation={validation}
        setValidation={setValidation}
      />

      {
        deleteModalShow &&
        <DeleteConfirmationModal
          handleDeleteYes={handleDeleteYes}
          setDeleteModalShow={setDeleteModalShow}
          deleteModalShow={deleteModalShow}
          name={selecteddeletebanner?.name}
        />
      }

      <ImageModal show={imageModal.isOpen} setShow={() => setImageModal({ isOpen: false, url: "" })} imageUrl={imageModal.url} />
    </>
  )
}
